import { Tooltip } from "antd";
import { isColorDark } from "common/buildMonoPalette";
import mergeClassNames from "common/mergeClassNames";
import { useScreenSize } from "hooks";
import React from "react";
import { DEFAULT_CUSTOMIZATION } from "store/tenancyCustomization/constants";

export interface IHeaderMenuItemProps {
    title: React.ReactNode;
    active?: boolean;
    icon?: React.ReactNode;
    onClick?: () => void;
    hideTitle?: boolean;
    className?: string;
    [key: string]: unknown; // Allow any other props (e.g. data-testid)
    colors?: Partial<ICustomizationData>;
}

export default function HeaderMenuItem({ title, icon, active = false, hideTitle = false, className = "", onClick, colors, ...props }: IHeaderMenuItemProps) {
    const { width } = useScreenSize();
    const [hover, setHover] = React.useState<boolean>(false);
    const isLargeScreen = React.useMemo(() => width >= 1280, [width]);

    return (
        <Tooltip title={title} destroyOnHidden arrow={false} open={hideTitle ? hover : !isLargeScreen && hover}>
            <div
                className={mergeClassNames("header-menu-item", active ? "active" : null, className)}
                style={{
                    backgroundColor: hover || active ? colors?.colorSelectedHeader || DEFAULT_CUSTOMIZATION.colorSelectedHeader : "transparent",
                    color: active
                        ? isColorDark(colors?.colorSelectedHeader || DEFAULT_CUSTOMIZATION.colorSelectedHeader)
                            ? "#FFFFFF"
                            : "#000000"
                        : colors?.colorNavigationFont || DEFAULT_CUSTOMIZATION.colorNavigationFont,
                }}
                onClick={onClick}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                {...props}
            >
                {icon}
                {!hideTitle && <span className={mergeClassNames("whitespace-nowrap xl:block", active ? "block" : "hidden")}>{title}</span>}
            </div>
        </Tooltip>
    );
}
